'use strict';

import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router';
import { PropTypes } from 'prop-types';
import ReactDOM from 'react-dom'
import classNames from 'classnames';

import { languageManager } from '../utils/languageManager'

import { platformHandler } from '../platforms/PlatformHandler'
import { selectCurrentData } from '../App/selectors';
import { connect }  from 'react-redux';

import { setSlidePreview } from '../App/actions';

import { COLOR, FONT_FAMILY, TEXT_SIZES }           from '../App/constants';

import WebViewFW from '../components/flipwitComponents/WebViewFW';
import FwModalLoader from '../components/FwModalLoader';

import { PluginHandler } from '../utils/pluginHandler';


import LiterallyCanvas from '../utils/literallycanvas-core'
import {FwScene} from './FwScene'
import { withStyles } from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

//import classNames from 'classnames';

//import { StyleSheet,  View, Image, Text, TextInput,Dimensions } from 'react-native';

//import { Paper,RaisedButton, IconToggle, Icon, themes, FloatingActionButton,} from 'carbon-ui'
//import { Platform } from 'react-native';
//import { em, sizeResponsive, sizeResponsiveLandscape, getValuePlatform, getX, getY } from "../utils/FWResponsive";
//import { COLOR, FONT_FAMILY, TEXT_SIZES }           from '../constants/Constants';
//import { requestPostSail } from '../utils/requester'

const webViewsPrueba = {
	//Este es el que se muestra dentro de la vista del usuario cuando es plugin pero no es hot, es de un slide
	//view: Normal, fullscreen: No
	//urlFinalPluginSlide:"http://192.168.1.53:3001",

	//Este es la que se muestra como hotPlugin Grande por ejemplo la pantalla de preguntas
	//view: Toda la pantalla
	//urlFinalHotPlugin: "http://192.168.1.53:3002",
}

const styles = theme => ({  
	flipwitContent: {
	    height: `${window.innerHeight - 64}px`,
	    display: 'flex',    
	    //justifyContent: 'center',
	    alignItems: 'center',
	    flexWrap: 'nowrap',    
	    flexDirection: 'column',     
	    width: '100%',
	    alignSelf: 'flex-start',
    	//marginTop: 32,

		'@media (orientation: landscape)': {
	      	flexDirection: 'row',
	    }	    
	},  

	imgContainer: {
		width: '100%',
		height: '100%',
	},

	media: {
		width: '100%',  		
    	height: '100%',
    	backgroundSize: 'contain',
    	position: 'relative',
    	display: 'flex',
    	alignItems: 'center',
	}, 	

	allContainers: {
		//width: '96%',
		backgroundColor: 'white',
		borderBottom: '1px solid #AAA',		
	},

	hiddenImg: {
		width: '100%',
    	height: '100%',
    	objectFit: 'contain',
    	userSelect: 'none',
    	//pointerEvents: 'none',
		//visibility: 'hidden',
	},

	drawer:{
		userSelect: 'none',
		pointerEvents: 'none',
		position: 'absolute',
		height: '100%',
		left: 0,
		top: 0,
		right: 0,
		bottom: 0,
	},

	slideImgContainer: {
		//height: 'calc(100% - 50px)',
		//borderBottom: '1px solid #AAA',		
		backgroundColor: '#EEEEEE',		
		display: 'flex',
		position: 'relative',
		//Ojo! Activar este filtro de abajo causa problemas de rendimiento en algunos moviles
		//filter: 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
		height: "calc(100% - 200px)",

		'@media (orientation: landscape)': {
	      	height: "calc(100% - 50px)",
	    }	
	},

	slideImgContainerNoAutoViewer: {
		height: "calc(100% - 50px)",
	},

	bigBoxContainers: {
		//margin: '5px', 
		height: '100%',
    	width: '100%',
    	display: 'flex',
    	flexDirection: 'column',
        justifyContent: 'center',
		borderBottom: '1px solid #AAA',	
        //height: 'auto',

		'@media (orientation: landscape)': {
	      	//flexDirection: 'row',
	    }	
	},

	enclosingDivs: {
		width: '50%',
    	display: 'flex',
    	justifyContent: 'center',
    	flexDirection: 'column',
    	borderTop: '1px solid #AAA',	
    	borderRight: '1px solid #AAA',	
	},

	slideBarContainer: {
		height: '50px',
		display: 'flex',
    	alignItems: 'center',    	
    	padding: 5,
    	justifyContent: 'space-between',
	}, 

	fullscreenDiv: {
	    height: '100%',
	    display: 'flex',
	    alignItems: 'center', 
	    fontSize: '1.1em',
	    fontFamily: 'Roboto-Medium',
	},

	navButtonContainer: {		
		//height: '20%',		
		maxHeight: 150,
		minHeight: '15%',
		display: 'flex',    
    	alignItems: 'center',
    	justifyContent: 'center',
    	marginTop: "auto",
	},

	navButtonContainerLandscape: {	
		flexDirection: "column",
	    paddingBottom: "10%",
	    maxHeight: "none",
	},

	bordersNoTop: {
		//margin: '2%',
		//marginTop: '0',
		width: '100%',
		//height: '100%',
		flex: 1,
	},

	divForArrows: {
		display: 'flex',
    	alignItems: 'center',
    	justifyContent: 'center',
    	height: '100%',
    	visibility: 'hidden',
	},

	arrowNavButton: {
		width: "80%",
    	height: "80%",
    	backgroundColor: COLOR.FLIPWIT_COLOR_1,
    	color: 'white',
    	'&:hover': {
	      background: COLOR.FLIPWIT_COLOR_2
	    }
	},

	fullScreenTools: {
		position: 'absolute',
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		width: '100%',
		height: '10%',
		bottom: 0,
		left: 0,
		right:0,
		backgroundColor: 'black',
		opacity: 0.4,
		display: "flex",
	},

	menuButton: {
      color: 'white',
      marginLeft: theme.spacing.unit,     
    },  

    hotContainer: {
		position: "absolute",
    	width: "100%",
    	height: "100%",	
    	zIndex: "10",
	},

	paperDialog: {      
      width: '100%', 
      height: '100%', 
      maxWidth: 'calc(100% - 4px)',
      maxHeight: 'calc(100% - 4px)',      
      margin: 0,
      display: 'flex',      
    },

    windowBar: {
		backgroundColor: COLOR.FLIPWIT_COLOR_1,
		width: '100%',		
		color: 'white',
		height: "64px",
    	display: 'flex',
    	alignItems: 'center',
	},

	title: {
	    fontSize: '1.1em',
	    fontFamily: 'Roboto-Medium',
	    fontWeight: 400,
	}, 

	buttonCrowdQuestions: {
		color: 'white',
	}
});



class PresentationUser extends FwScene {
	constructor(props) {
	  	super(props);	
	  	this.pluginHandler = new PluginHandler();
	  	this.firstImageLoaded = false;

	  	this.shapeObject = LiterallyCanvas.createShape( 'Ellipse',
	  			{	
	  			 fillColor: "rgba(255,0,0,1)",
	  			 height: 10,
	  			 strokeColor: "rgba(255,0,0,1)",
	  			 strokeWidth: 5,
	  			 width: 10,
	  			 x: 10,
	  			 y: 10
	  			}
	  		);

    	/*if( platformHandler.isFullScreenSupported()) {
    		this.buttonFullScreen = <IconToggle name="&#xE5D0;" onPress={() => this.setFullScreen()} 
    			style={ { marginRight: sizeResponsive(2),} } 
    			iconStyle={ { color:themes.light.colors.primary, fontSize: em(TEXT_SIZES.CLOCK)}} />;
    	}*/

	   	if( ! this.props.history.location.state.autoViewer ){
	  		//window.DEBUG_FLIPWIT('Coloca para presence que estoy con ' + this.props.currentData.idUserPresentation);
	  		platformHandler.reportAndListenPresence(this.props.currentData.idUserPresentation, platformHandler.nick);
    	}
	  	
	}

	componentWillUnmount() {
		clearInterval(this.intervalCheckHeight);
		window.onfocus = null;

		window.onpopstate = () => {}
	}

	initPresentationUser() {

		console.log('Entra a init user con autoviewer ', this.props.history.location.state.autoViewer)
		document.body.scrollTop = 0;
		platformHandler.checkTitleBarScene("PresentationUser");

		if( this.props.history.location.state.autoViewer ){
			platformHandler.setListenerAutoviewer( this.dataFirebase );
		}
		else{
			platformHandler.setListenerPresentation( this.dataFirebase, this.props.currentData.idUserPresentation );
			platformHandler.setHotPluginListener(this.hotPluginListener, this.props.currentData.idUserPresentation )
			platformHandler.listenUserConnections( this.props.currentData.idUserPresentation );
		}

	    //let node = ReactDOM.findDOMNode(this.fullImage);
	    let node = ReactDOM.findDOMNode(this.imageCont);
		if (node){
			this.nodeLeft = node;
			//this.initialStyleWidth = this.nodeLeft.style.width;
		  	this.calculateHeightLeftNode();
		  	//this.intervalCheckHeight = setInterval( this.calculateHeightLeftNode, 500);
		}

		window.onfocus = this.reloadAfterFocus;
		
		platformHandler.setUpdatePointer( this.updatePointer );
		
		if( !platformHandler.isLAN ){
			
			var imagePrefetch = [];
			var total = this.props.currentData.totalSlides;
			var imgPath = this.props.currentData.previewUrl;

			setTimeout(function() {
				
				for(var i=2; i<=total; i++) {
					const img = document.createElement('img');
					var nextImg = imgPath.replace("%2F1.jpg", "%2F"+i+".jpg");
					console.log('requesting ',nextImg)
					img.src = nextImg;
					imagePrefetch.push(img);
				}

				Promise.all(imagePrefetch).then(results => {
				});
	  		}, 3000);			
		}
	}

	componentDidMount() {

		console.log('fullsupported ', platformHandler.isFullScreenSupported())
    	if( platformHandler.isFullScreenSupported()) {
    		this.setState({fullscreenSupported:true})    		
    	}

		setTimeout(this.initPresentationUser.bind(this), 1000);
		window.addEventListener("resize", this.updateDimensions);

		console.log('USERR',this.props.currentData.idUserPresentation)


		/*console.log('PROPS', this.props)

		if (this.props.history.action === "POP") {
	        // custom back button implementation
	        this.openModal({title:languageManager.getLangWord("CONFIRMATION"),message: languageManager.getLangWord("CONFIRMATION_CLOSE_TEXT")
        								,buttons: [{label:languageManager.getLangWord("YES"),callback:() => alert('salir')},{label:languageManager.getLangWord("NO")}]})
	    }*/

		//window.onpopstate = this.handleBackClick.bind(this)

		
    	//this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
		/*window.history.pushState(null, document.title, window.location.href);
	   	window.addEventListener('popstate', function (event){
	       window.history.pushState(null, document.title,  window.location.href);
	   	});*/

	   	window.onpopstate = (e) => {
	        e.preventDefault();

	        this.openModal({title:languageManager.getLangWord("CONFIRMATION"),message: languageManager.getLangWord("CONFIRMATION_CLOSE_TEXT")
        								,buttons: [{label:languageManager.getLangWord("YES"),callback:() => this.props.history.goBack()},{label:languageManager.getLangWord("NO")}]})
	    	return true;
	    }

	}

	handleBackClick(){
	 this.props.history.push(this.props.location.pathname)
	 this.openModal({title:languageManager.getLangWord("CONFIRMATION"),message: languageManager.getLangWord("CONFIRMATION_CLOSE_TEXT")
        								,buttons: [{label:languageManager.getLangWord("YES"),callback:() => alert('salir')},{label:languageManager.getLangWord("NO")}]})
	}

	routerWillLeave(nextState) { // return false to block navigation, true to allow
		if (nextState.action === 'POP') {
		  // handle "Back" button clicks here

		  return false;
		}
	}


	updateDimensions = () => {
		console.log('resize',this.state, platformHandler.isFullScreen())
		console.log();

		if(this.mainDiv!==undefined && this.mainDiv!==null) {
			this.mainDiv.style.height = (window.innerHeight - 64) + 'px'
		}

		
		this.handleDrawer();		
		this.forceUpdate();		
    }

	reloadAfterFocus = () => {
		if( !this.props.currentData.previewUrl.endsWith("=") ){
			var tempDate = new Date().getTime();
			this.dispatch(setSlidePreview( this.props.currentData.previewUrl + "&toglea=" + tempDate ));
		}
		
	}

	calculateHeightLeftNode = () => {

		let nodeCompare = this.nodeLeft;
		//console.log('entra ' + nodeCompare.clientHeight + " state " + this.state.heightPreview + " width node" + nodeCompare.clientWidth + " state " + this.state.widthPreview)
		if( platformHandler.isFullScreen()){
			
			nodeCompare = this.nodeFull;
			nodeCompare.style.width = "100%";
			//nodeCompare.style.height = "100%";
		}
		else{
			nodeCompare.style.width = this.initialStyleWidth;
		}

		let calculatedHeight = nodeCompare.clientHeight ;
		let calculatedWidth = nodeCompare.clientWidth;

		//se puso los dos porque si se abre el teclado solo se modifica el alto
		if( calculatedHeight != this.state.heightPreview && 
			calculatedWidth != this.state.widthPreview ){
			this.date = new Date().getTime();
			this.setState( {heightPreview: calculatedHeight, widthPreview: calculatedWidth });
			console.log('cambio pero no')
			if( this.props.currentData.idToglea == ""){
				this.handleDrawer();
			}
			//nodeCompare.style.width = "100%";
			//this.nodeLeft.style.height = "100%";
			
		}
	}

	hotPluginListener = (data) => {

		let hasPlugin = data.activated;

		if(hasPlugin) {
			this.setState({showHotPluginInView:data});			
		}
		else {
			this.setState({showHotPluginInView:null});						
		}
		
	}

	state = {
	    innerUrl: '/user',	    
	    heightPreview: 0,
	    widthPreview: 0,
	    showLoader: true,
	    widthImg: 0,
	    heightImg: 0,
	    dataImgDrawing: "",
	    showHotPluginUser: null,
	}

	dataFirebase = (success,data) => {

		console.log('Data from firebase',data)
		if (data) {
			//Si es la informacion estatica, esta es por ejemplo la cantidad de diapositivas
			//ese numero no cambia en medio de la presentacion
			if(data.isStaticInfo!==true) {
				//window.DEBUG_FLIPWIT('data: ' + data.communData )
				if( data.communData != undefined ){

					if( data.communData.idToglea != "" ){
						this.startLoader();
						this.setState( {innerUrl: '/user' })
					}
					else{
						this.setState( {dataImgDrawing: data.imgDrawing })
						
						if( this.props.currentData.previewUrl != data.communData.previewUrl ){
							this.startLoader();
						}
						else{
							//Si llego la información del snapshot pero no ha pintado aun la imagen entonces
							//no muestra nada pues cuando se termine de pintar ella lo cargará y si se hace acá 
							//va a salir el dibujo sin imagen de fondo y se ve feo
							if(!this.firstImageLoaded) return;

							console.log('Llega de firebase snapshot', this.state.dataImgDrawing)

							this.handleDrawer();
							//this.lc.loadSnapshot(this.state.dataImgDrawing)
	

							/*if( data.pointer ){
								this.updatePointer( data.pointer.visible, data.pointer.x, data.pointer.y)
							}*/
						}
					}
					
				}
				
			}
		}
	}

	startLoader = () => {
		this.date = new Date().getTime();
		this.setState({ showLoader:true }) 
	}

	onReceiveMessage = (msg) => {
	    window.DEBUG_FLIPWIT('--> recibio: ' + msg)
	    let jsonMsg = JSON.parse( msg );
	    if( jsonMsg.cmd == 'changeToViewer' ){
			console.log('OJOOO CAMBIA')
	    	this.startLoader();
	    	this.setState( {innerUrl: '/viewer' })
	    }
	    else{
	    	if( ! this.props.history.location.state.autoViewer || msg.indexOf("lastMsgActivity") >= 0
	    		|| msg.indexOf("getExhibitorMsgs") >= 0 || msg.indexOf("initInfo") >= 0){
	    		console.log('Entra al if con ',msg)
	    		this.pluginHandler.messageFromWebPlugin( jsonMsg, this._child, this.props.currentData, false, this.props.history.location.state.autoViewer);
	    	}
	    }
	};

	onReceiveMessageForHotPluginViewer(msg){
		console.log('recibio for webPlugin: ', msg,this.webHotPluginViewer)
		if(msg==undefined) return;
		let jsonMsg = JSON.parse( msg );

		if( jsonMsg.cmd == 'changeToViewer' ) {
			var showHotPluginInView = this.state.showHotPluginInView;
			showHotPluginInView.userView = 'viewer';		
			this.setState({showHotPluginInView});			
		}
		else {
			this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webHotPluginViewer, this.props.currentData, false);
		}		
	}

	onReceiveMessageForHotPluginInfo(msg){
		if(msg==undefined) return;
		console.log('recibio for webPlugin: ', msg,this.webHotPluginInfo)
		let jsonMsg = JSON.parse( msg );
		
		this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webHotPluginInfo, this.props.currentData, true);
	}

	onButtonPress( action ){
	    platformHandler.autoviewerAction( action, this.props.currentData );
	};

	setFullScreen = () => {

		let node = ReactDOM.findDOMNode(this.imageCont);

		if (node){
			this.nodeFull = node;
		}

		platformHandler.toggleFullScreen( this.nodeFull );

		if( this.intervalCheckHeight == null ){
			this.intervalCheckHeight = setInterval( this.calculateHeightLeftNode, 500);
		}

	}

	paintVisor(currentData){

		const { classes } = this.props;		

		//<div id="imgContainer" className={classes.imgContainer} onClick={() => {console.log('Click en imagen')}}>

		//if(this.state.showLoader) this.setState({ showLoader:false });

		//this.onImageLoaded("test");

		return (
			<div id="imgContainer" className={classes.imgContainer}>
				<div
					id="imgPresentationMode"
		        	className={classes.media}
		        	//image={currentData.previewUrl}
		        	//onLoad={this.onImageLoaded}
		        >
		        	{/*<image src={currentData.previewUrl} />*/}
		        	{<div id="divDrawer" className={classes.drawer} />}
		        	{/*<div id="divDrawer2" className={classes.drawer}>
		        		<div id="lc-drawing-div" className="lc-drawing" style={{pointerEvents: 'none',
		        		backgroundColor: "red",
		        		position: "absolute",
		        		left: "359.611px",
		        		top: "0px",
		        		width: "273.778px"}}>
		        			<canvas id="canvasFront2" className="lc-canvas" style={{
		        			pointerEvents: "none",
		        			backgroundColor: "blue",
		        			width: "273.778px",
		        			height: "154px",
		        			position: "absolute",
		        			left: "0px", 
		        			top: "0px"}} width="274" height="154"></canvas>
		        		</div>
		        	</div>*/}
					{<img id="hiddenImg" className={classes.hiddenImg} src={currentData.previewUrl} onLoad={this.onImageLoaded} />}
		        </div>
			</div>
		);

		//

		return null;
		/*return (
			<Image source={{uri: currentData.previewUrl}} ref={(child) => { this.imageComp = child; }}
			style={styles.imagePreviewInt}
			resizeMode={'contain'}
			onLoad={this.onHandleReady}>
				<View style={styles.drawer} id={"divDrawer"}/>
			</Image>
		);*/
	}

	onImageLoaded = (e) => {

		//Si recibe como parametro el string test, es simplemente para en modo pruebas poder 
		//quitar el cargador de la imagen
		if(e==="test") {
			if(this.state.showLoader) this.setState({ showLoader:false }) 
			return;
		}

		if(e==undefined) return;
		console.DEBUG_FLIPWIT('CARGOOOOOOOOOOOOOOOOOO ' + this.props.currentData.previewUrl,e.nativeEvent.srcElement.width,e.nativeEvent.srcElement.height,e.nativeEvent.srcElement,e.nativeEvent.srcElement.naturalWidth)
		
		//this.setState( {heightPreview: e.nativeEvent.srcElement.height });
	
			
		//compruebe solo si no es el preview y no es una actividad de toglea
		if( this.props.currentData.previewUrl.indexOf("images/nopreview.png") == -1 && this.props.currentData.idToglea == ""){
			this.setState({ showLoader:false }) 					
			try{
				if( e.nativeEvent.srcElement ){
					this.setState({ widthImg:e.nativeEvent.srcElement.naturalWidth, heightImg: e.nativeEvent.srcElement.naturalHeight },() => {
					//this.setState({ widthImg:e.nativeEvent.srcElement.width, heightImg: e.nativeEvent.srcElement.height },() => {
						console.log('>>>>>>>>>>>>SETEA ESTADO WID2 ', this.state.widthImg,this,this.state)
						this.handleDrawer(true);
						
					}) 
					console.log('>>>>>>>>>>>>SETEA ESTADO WID ', e.nativeEvent.srcElement.width, this.state.widthImg,this,this.state)
				}
				else{
					this.setState({ widthImg:e.nativeEvent.path[0].width, heightImg: e.nativeEvent.path[0].height }, () => {
						this.handleDrawer(true);
					}) 
				}
			}
			catch(e){
				console.log('ERROR getting width n height', e)
			}
			
			//setTimeout( this.checkImage,200);				
		}
			
	}

	onHandleReady = (e) => {
	    this.setState({ showLoader:false }) 

	    console.log('event ' , e)
	    if( this.props.currentData.idToglea == ""){
	    	try{
	    		if( e.nativeEvent.srcElement ){
	    			this.setState({ widthImg:e.nativeEvent.srcElement.width, heightImg: e.nativeEvent.srcElement.height }) 
	    		}
	    		else{
	    			this.setState({ widthImg:e.nativeEvent.path[0].width, heightImg: e.nativeEvent.path[0].height }) 
	    		}
	    		this.handleDrawer();
	    	}
	    	catch(er){
	    		console.log('ERROR getting width n height', er)
	    	}
			//setTimeout( this.checkImage,200);
		}

		this.forceUpdate();
	}

	/*checkImage = () => {
		let nodeImage = ReactDOM.findDOMNode(this.imageComp);

		if (nodeImage){
			let backTemp = nodeImage.style.backgroundImage;
			window.DEBUG_FLIPWIT('COMPARA')
			if( backTemp == undefined || backTemp == "" ){
				window.DEBUG_FLIPWIT('NO HAYYYYYYYYY')
				nodeImage.style.backgroundImage = "url(" + this.props.currentData.previewUrl + ")"
			}
			
		}
	}*/

	//fullHeight es un boleano que dice si el plugin va a ocupar todo el espacio de la pantalla
	paintPlugin(currentData,fullHeight){
		console.log('que pone: ' + currentData.urlActivity + this.state.innerUrl + '/?' + this.date)

		const { classes } = this.props;		

		let urlActivity = currentData.urlActivity;

		//TODO2
		urlActivity = currentData.urlActivity.replace("plugins", "pluginsTest");

		/*if(this.state.innerUrl==="/user") {
			console.log('Sobreescribe para pruebas a urlActivity por ser user')
			urlActivity = "http://localhost:3001" + '/?' + this.date;
		}
		else 
		{
			console.log('NO sobre escribe')
			urlActivity = urlActivity + this.state.innerUrl + '/?' + this.date
		}*/
		var urlFinalPluginSlide = urlActivity + this.state.innerUrl + '/?' + this.date;
		
		if(webViewsPrueba.urlFinalPluginSlide!==undefined) {
			urlFinalPluginSlide = webViewsPrueba.urlFinalPluginSlide;
		}

		/*if(currentData.urlActivity.indexOf("url")!==-1) {
			urlFinal = "http://localhost:3001/"
		}*/

		//urlFinal = "http://192.168.1.53:3001/"

		//this.date = new Date().getTime();
		
		if(fullHeight) {
			let styleDivContainer = {display: 'flex', width: '100%', height: '100%', flexDirection: 'column'};

			return(<React.Fragment>       
					<Dialog
			          open={true}
			          classes={{ paper: classes.paperDialog }}          
			        >
			        	{this.state.showLoader && <FwModalLoader />}
			        	<div style={styleDivContainer}>
							<WebViewFW ref={(child) => { this._child = child }}
								name="iframeUser"
								id={"iframeUser"+this.date}
								key={"iframeUser"+this.date}
							    urlWebView={urlFinalPluginSlide}
							    style={{backgroundColor: 'white',width:'100%'}}
							    height={'100%'}					    
							    handleReady={this.onHandleReady}
							    handleReceiveMessage={this.onReceiveMessage}					    
						  	/>	
			        	</div>
			        </Dialog>
		    	</React.Fragment>
		   	);
		}
		else 
		{
			return (
				<WebViewFW key={this.date} ref={(child) => { this._child = child; }}
					name="iframeUser"
					id={"iframeUser"+this.date}
					key={"iframeUser"+this.date}
				    urlWebView={urlFinalPluginSlide}
				    height={"100%"}
				    style={{height:"initial"}}
				    handleReady={this.onHandleReady}
				    handleReceiveMessage={this.onReceiveMessage}
				  />
			);			
		}
	}

	handleDrawer = (firstCall = false) =>{

		//Si no se ha terminado de cargar la primera imagen entonces ignora el llamado
		if(!firstCall && !this.firstImageLoaded) return;

		this.firstImageLoaded = true;
		console.log('LO CREA')
		var elementToMatch = document.getElementById("divDrawer");
		if( elementToMatch == null ) return;

		//this.lc = LiterallyCanvas.init(elementToMatch, { tools:[LiterallyCanvas.tools.Eyedropper],removePointerEvents:true }, this.state.widthImg, this.state.heightImg);
		this.lc = LiterallyCanvas.init(elementToMatch, { removePointerEvents:true }, this.state.widthImg, this.state.heightImg);
		this.lc.loadSnapshot(this.state.dataImgDrawing)
		platformHandler.setDrawingCanvas( this.lc, this.handleDrawer );
	}

	updatePointer = ( visible, data  ) =>{
		if( visible ){
			if( data ){
				const pointsArray = Object.values(data);
				if( pointsArray.length > 0 ){
					const point = pointsArray[ pointsArray.length - 1];
					console.log('paoint', point)
					this.shapeObject.x = point.x;
					this.shapeObject.y = point.y;
					this.lc.drawShapeInProgress( this.shapeObject );
				}				
			}
		}	
		else{
			if( this.lc ){
				this.lc.repaintLayer('main', false);
			}
		}			
	}

	getOrientation() {
		console.log('Pide orientation con ',document.documentElement.offsetWidth,document.documentElement.offsetHeight)
		return document.documentElement.offsetWidth > document.documentElement.offsetHeight?"landscape":"portrait";
	}

	tryShowFSTools = () => {
		if( platformHandler.isFullScreen() ) {
			if(!this.state.showFSTools)
			{
				this.setState( {showFSTools: true });		
				this.timeoutTools = setTimeout( this.hideFSTools,3000);		
			}
			else {
				clearTimeout( this.timeoutTools );
				this.timeoutTools = setTimeout( this.hideFSTools,3000);			
			}
		}
	}

	hideFSTools = () =>{
		this.setState( {showFSTools: false });
	}

	paintFullScreenTools = ( currentData ) =>{
		if( ! platformHandler.isFullScreen() ){
			return null;
		}


		if( !this.state.showFSTools ){
			return null;
		}

		/*<View style={styles.toolsFS}>
			<IconToggle name="&#xE5D1;" onPress={() => this.setFullScreen()} 
			    			style={ stylesCarbon.iconos } 
			    			iconStyle={ { color:themes.light.colors.primary, fontSize: TEXT_SIZES.CLOCK}} />;
		</View>*/

		return(
			<div className={this.props.classes.fullScreenTools}>
				<IconButton
	              color="inherit"
	              onClick={() => this.setFullScreen()}                
	              className={this.props.classes.menuButton}	     
	              classes={{label:this.props.classes.iconMenuBar}} 
	              style={{margin: "8px",marginRight: "4%"}}        
	            >
	              <FullscreenExitIcon style={{width: '100%',height: '100%'}}/>
	            </IconButton>
			</div>
		);
	}

	closeHotPlugin = () => {
		this.setState({showHotPluginUser:null});
		//platformHandler.deactivateHotPlugin();
		//this.props.dispatch( setPresentationModeConfig("showHotPlugin", null));    	
	}
		
	verifyConnectWithoutAsk = (dataJoin) => {
	    try {
	      return this.dataJoin.resp.config.connectWithoutAsk?true:false;
	    }
	    catch(e) {
	      return false;
	    }
	  }

	//Lo que se carga dentro del espacio del viewer
	getHotPluginInView = () => {

		const { classes } = this.props;		
		
		console.log('--> hot llega con ', this.state.showHotPluginInView)
		
		//TODO, esto no debe ser para una cuenta sino configurable
		let showHotPluginInfoInView = this.props.currentData.idUserPresentation!=="flipwitstartupbattlefield-iype";


		if(this.state.showHotPluginInView!==null && this.state.showHotPluginInView!==undefined && showHotPluginInfoInView) {
			
			if(this.state.showHotPluginInView.userView==='none') return;

			let showHotPluginFullScreen = this.state.showHotPluginInView.showFullScreenInUser || false;


			let urlActivity = 'https://app.flipwit.com/plugins/' + this.state.showHotPluginInView.pluginName + '/' + this.state.showHotPluginInView.userView + '/?';

			//TODO2
			urlActivity = urlActivity.replace("plugins", "pluginsTest");

			/*if(this.state.showHotPluginInView.pluginName==="wordcloud") {
				if(this.state.showHotPluginInView.userView==="user") {
					urlActivity = "http://localhost:3001/?";
				}

				if(this.state.showHotPluginInView.userView==="viewer") {
					urlActivity = "http://localhost:3002/?";
				}
			}*/
			
			let styleDivContainer = {display: 'flex', width: '100%', height: '100%', flexDirection: 'column'};

			var urlFinal = urlActivity + this.date;

			//urlFinal = "http://192.168.1.53:3001/"
		
			var style = {backgroundColor: 'white',width:'100%'};

			if(this.state.showHotPluginInView.whiteBackground===false) {
				delete style.backgroundColor;
			}

			let webViewFrame = 
					<WebViewFW ref={(child) => { this.webHotPluginViewer = child; }}
						name="webHotPluginViewerUser"
						key="webHotPluginViewerUser"
					    urlWebView={ urlFinal  }
					    //urlWebView={ "http://localhost:3001/?" + this.date }
					    //urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/viewer/?" + this.date }
					    //pointerEvents={"none"}
					    style={style}
					    //style={{backgroundColor: 'white',minHeight: this.state.heightPreview,width:'100%'}}
					    height={'100%'}					    
					    handleReady={() => {this.setState({showLoader:false})}}
					    handleReceiveMessage={this.onReceiveMessageForHotPluginViewer.bind(this)}					    
				  	/>	;

			if(showHotPluginFullScreen) {
				return(
					<React.Fragment>       
						<Dialog
				          open={true}
				          classes={{ paper: classes.paperDialog }}          
				        >
							<div style={styleDivContainer}>
								{webViewFrame}		  	
							</div>
						</Dialog>
			    	</React.Fragment>
				);				
			}
			else {
				return(
					<div className={classes.hotContainer}>
						{webViewFrame}	  	
					</div>
				);				
			}
		}
	}

	//Lo que se carga en pantalla completa
	getHotPluginInfo() {
	
		console.log('Aca llega para hot con ',this.state.showHotPluginUser,this.props.currentData.idUserPresentation)
		//TODO, esto no debe ser para una cuenta sino configurable
		let showHotPluginInfo = this.props.currentData.idUserPresentation!=="flipwitstartupbattlefield-iype";

		if(this.state.showHotPluginUser!==null && showHotPluginInfo) {

			const { configPresentationMode, classes } = this.props;		
			//const { classes } = this.props;		
			var isElectronExhibitor = (platformHandler.isElectron && !platformHandler.isCloud() );
			
			var paramOptional = "";
			if( isElectronExhibitor ){
				paramOptional = "electron=true&";
			}

			paramOptional += "presMode=true&";

			let urlActivity = 'https://app.flipwit.com/plugins/' + this.state.showHotPluginUser + '/user/?';

			//TODO2
			urlActivity = urlActivity.replace("plugins", "pluginsTest");

			let styleDivContainer = {display: 'flex', width: '100%', height: '100%', flexDirection: 'column'};

			var urlFinalHotPlugin = urlActivity + paramOptional + this.date

			if (webViewsPrueba.urlFinalHotPlugin !== undefined) {
				urlFinalHotPlugin = webViewsPrueba.urlFinalHotPlugin;
			}
			
			return(<React.Fragment>       
					<Dialog
			          open={true}
			          classes={{ paper: classes.paperDialog }}          
			        >
			        	{this.state.showLoader && <FwModalLoader />}
			        	<div className={classes.windowBar}>
							<IconButton color="inherit" onClick={() => this.closeHotPlugin()}>
						        	<ArrowBackIcon />				        	
						    </IconButton>				
						    <div className={classes.title}>{languageManager.getLangWord("QUESTIONS_FOR_EXHIBITOR")}</div>		    		    
			        	</div>
			        	<div style={styleDivContainer}>
							<WebViewFW ref={(child) => { this.webHotPluginInfo = child; }}
								name="webHotPluginInfoUser"
								key="webHotPluginInfoUser"
							    urlWebView={ urlFinalHotPlugin  }
							    style={{backgroundColor: 'white',width:'100%'}}
							    height={'100%'}					    
							    handleReady={() => {this.setState({showLoader:false})}}
							    handleReceiveMessage={this.onReceiveMessageForHotPluginInfo.bind(this)}					    
						  	/>	
			        	</div>
			        </Dialog>
		    	</React.Fragment>
		   	);
		}
	}

	showCrowdQuestionsHotPlugin = () => {
		this.setState({showLoader:true,showHotPluginUser: "crowdquestions"})
	}

	render() {
		console.log('Auto ',this.props.history.location.state.autoViewer)
		const {classes, currentData, dispatch} = this.props;
    	this.dispatch = dispatch;

		//ContentPreview es lo que se pinta en el lugar donde se muestra la diapositiva
    	let contentPreview = null;
    	//ContentPlugin es lo que se pinta como plugin de toda la pantalla, antes el plugin tambien se pintaba en el lugar
    	//de la diapositiva pero eso cambio para tener mas espacio, no obstante si estan en fullscreen entonces si se pinta en 
    	//el lugar de la diapositiva pues ese es el espacio que se pone de fullscreen
    	let contentPlugin = null;

    	if( currentData.idToglea == ""){
    		contentPreview = this.paintVisor(currentData);
    	}
    	else
    	{			
    		//En fullscreen o en autoviewer no lo pinta de toda la pantalla
			if(platformHandler.isFullScreen() || this.props.history.location.state.autoViewer) {
    			contentPreview = this.paintPlugin(currentData,false);
			}
			else {
				contentPlugin = this.paintPlugin(currentData,true);
			}
    	}

		//Por ahora solo se va a usar el diseño portrait
		let landscapeOrientation = false;//this.getOrientation()=="landscape";

		let useAutoviewer = this.props.history.location.state.autoViewer

		let showExhibitorQuestionButton = this.props.currentData.idUserPresentation!=="flipwitstartupbattlefield-iype";

		console.log('CONFIGGG',platformHandler.currentSlidesConfig);
		
		//Si la presentacion tiene en la base de datos en la configuracion el parametro showQuestionButton entonces
		//activa este flag para no mostrar ese botón
		if(platformHandler.currentSlidesConfig!== undefined && 
			platformHandler.currentSlidesConfig!==null && 
			!platformHandler.currentSlidesConfig.showQuestionButton) {
			
			showExhibitorQuestionButton = false;			
		}

		console.log('USERR 2',showExhibitorQuestionButton,this.props.currentData.idUserPresentation)

    	//var applyLandscape = this.props.orientation=='landscape'&&platformHandler.isMobileAndTablet;
    	
    	let slideContainer = <div id="slideContainer" className={classNames(!useAutoviewer && classes.slideImgContainerNoAutoViewer, classes.slideImgContainer)} ref={(child) => { this.imageCont = child; }}
    							onMouseMove={() => {this.tryShowFSTools()}}>
    							{this.getHotPluginInView()}
								{contentPreview}		
								{this.paintFullScreenTools(currentData)}								
							</div>

		let slideBarContainer = <div className={[classes.slideBarContainer,classes.allContainers].join(' ')}>
									{/* Este siguiente item se coloca con la unica intención de hacer centrar bien el item del 
									centro 1/23 ya que asi el flex distribuye efectivamente el espacio, por eso se coloca con visibility hidden*/}
									{this.state.fullscreenSupported && <div className={classes.fullscreenDiv} style={{visibility:"hidden"}}>
										<IconButton
						                  aria-label="More"
						                  aria-haspopup="true"
						                  color="inherit"                
						                  onClick={this.setFullScreen}  
						                  className={classes.subMenuBackButton}
						                >
						              		<FullscreenIcon />
						              	</IconButton>							          
							        </div>}
									<div className={classes.fullscreenDiv}>
										{currentData.indexSlide<0?"-":currentData.indexSlide}/{currentData.totalSlides<=0?"-":currentData.totalSlides}
									</div>
									{this.state.fullscreenSupported && <div className={classes.fullscreenDiv}>
										<IconButton
						                  aria-label="More"
						                  aria-haspopup="true"
						                  color="inherit"                
						                  onClick={this.setFullScreen}  
						                  className={classes.subMenuBackButton}
						                >
						              		<FullscreenIcon />
						              	</IconButton>							          
							        </div>}
							        {!this.state.fullscreenSupported && <div style={{width:50}}></div>}
								</div>

		
		let styleButtonPrev = {
			width: landscapeOrientation?'70%':'20%',
			height: '100%',
		}

		let styleButtonNext = {
			width: landscapeOrientation?'80%':'20%',
			height: '100%',
		}

		let navButtonContainer = 	<div className={classNames(landscapeOrientation && classes.navButtonContainerLandscape, classes.navButtonContainer,classes.allContainers,classes.bordersNoTop)}>
										<div id="buttonPrevCont" className={classes.divForArrows} style={styleButtonPrev}>
											<IconButton
												aria-label="More"
								                aria-haspopup="true"
								                color="inherit"                
								                onClick={() => {this.onButtonPress("Prev")}}  
								                className={classes.arrowNavButton}
							                >
							              		<ArrowBackIcon style={{width: '50%',height: '50%'}}/>
							              	</IconButton>						              								              	
										</div>
										<div id="buttonNextCont" className={classes.divForArrows} style={styleButtonNext}>
											<IconButton
												aria-label="More"
							                	aria-haspopup="true"
							                	color="inherit"                
							                	onClick={() => {this.onButtonPress("Next")}}  
							                	className={classes.arrowNavButton}
							                >
							              		<ArrowForwardIcon style={{width: '50%',height: '50%'}}/>
							              	</IconButton>													
										</div>
									</div>

		let navButtonContainerConnectedAudience = <div style={{justifyContent: 'center'}} className={classNames(landscapeOrientation && classes.navButtonContainerLandscape, classes.navButtonContainer,classes.allContainers,classes.bordersNoTop)}>
													<Button className={classes.buttonCrowdQuestions} variant="contained" color="secondary" onClick={this.showCrowdQuestionsHotPlugin}>
											        	{"PREGUNTAS AL EXPOSITOR"}
											        </Button>					              								              											
												</div>


		/*<View style={styles.container} ref={(child) => { this.imageCont = child; }}>
			<View style={applyLandscape?styles.innerContainerLandscape:(platformHandler.isMobileAndTablet?styles.innerContainer:styles.innerContainerPC)} ref={(child) => { this.fullImage = child; }}>
				<View style={styles.containerContent}>
					{contentPreview}
					<Loader active={this.state.showLoader}/>
				</View>		
			</View>	
			<View style={styles.infoSlide}>
					<View style={styles.indexSlide}>
						{ this.props.history.location.state.autoViewer &&
						<FloatingActionButton onPress={() => this.onButtonPress("Prev")} style={ stylesCarbon.floatingButton }>
							<Icon name="&#xE5C4;" selectable={false} style={stylesCarbon.arrowPrevious} />
						</FloatingActionButton>
						}
						
						<View style={styles.viewInfo}>
							<Text style={styles.textSlide}>{currentData.indexSlide}/{currentData.totalSlides}</Text>
						</View>	

						{ this.props.history.location.state.autoViewer &&
							<FloatingActionButton onPress={() => this.onButtonPress("Next")} style={ stylesCarbon.floatingButton }>
								<Icon name="&#xE5C8;" selectable={false} style={stylesCarbon.arrowPrevious} />
							</FloatingActionButton>
						}
					</View>

					<View style={styles.toolsViewer}>
						{this.buttonFullScreen}
					</View>
				</View>
			</View>*/

		//-------------------------------------------------------------------------------
		//Para hacer que los botones queden circulares toca por js arreglar el ancho y el alto
		let elementsToFix = ["buttonPrevCont","buttonNextCont"];
				
		setTimeout(() => {
			elementsToFix.map(
				function(el) {
					let elementCt = document.getElementById(el);

					if(elementCt==null) return;
					
					if(elementCt.offsetWidth>elementCt.offsetHeight && !landscapeOrientation) {
						elementCt.style.width = elementCt.offsetHeight + 'px';
					}
					else {
						elementCt.style.height = elementCt.offsetWidth + 'px';		
					}

					elementCt.style.visibility = "visible";					
				}
			)
		}, 10)
			

    	return(
				<React.Fragment>		
					{this.state.showLoader && <FwModalLoader />}				
					<div className={classes.flipwitContent} ref={(child) => { this.mainDiv = child; }}>
						{contentPlugin}
						{this.getHotPluginInfo()}
						<div className={[classes.allContainers,classes.bigBoxContainers].join(' ')}>
							{!landscapeOrientation && <React.Fragment>
								{slideContainer}
								{slideBarContainer}
								{useAutoviewer && navButtonContainer}
								{!useAutoviewer && showExhibitorQuestionButton && navButtonContainerConnectedAudience}
							</React.Fragment>}
							{landscapeOrientation && <React.Fragment>
							<div className={classes.enclosingDivs} style={{width: useAutoviewer?'80%':'100%'}}>
								{slideContainer}
								{slideBarContainer}
							</div>
							{useAutoviewer && <div className={classes.enclosingDivs} style={{width: '20%'}}>
								{navButtonContainer}
							</div>}
							{!useAutoviewer && showExhibitorQuestionButton && <div className={classes.enclosingDivs} style={{width: '20%'}}>
								{navButtonContainerConnectedAudience}
							</div>}
							</React.Fragment>}
						</div>						
					</div>
				</React.Fragment>
		);	
    }
}

/*
{landscapeOrientation && <React.Fragment>
							<div className={classes.enclosingDivs}>
								{slideContainer}
								{slideBarContainer}
							</div>
							{useAutoviewer && <div className={classes.enclosingDivs}>
								{navButtonContainer}
							</div>}
							</React.Fragment>}
 */

PresentationUser.propTypes = {
  	currentData: PropTypes.object.isRequired,
	dispatch: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	history: PropTypes.object,
};

PresentationUser.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	currentData: selectCurrentData(state),  	  	
  	language: state.containers.appReducer.language,
  }
};

export default  connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(withRouter(PresentationUser)) );


// WEBPACK FOOTER //
// ./src/containers/scenes/PresentationUser.js